import React, { useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import {  Typography, Button, Snackbar} from '@material-ui/core';


import {
   ContentCopyOutlined,
  LinkOutlined,
     NumbersOutlined,
      OpenInNewOutlined,
      ReceiptOutlined,
      WhatsApp
     } from '@mui/icons-material';

const useStyles = makeStyles((theme) => ({

  rowResent: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'start',
    alignItems: 'start',
    backgroundColor: theme.palette.background.orange,
    borderRadius: "0.5rem",
    marginTop: theme.spacing(1),
    padding :  theme.spacing(2),
  },


  message: {
    margin: 0,
    padding: 0,
    textAlign: 'justify'
  },

  rowButtons: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    justifyContent: 'end',
    alignItems: 'center',
    borderRadius: "0.5rem",
  },

  rowItem: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderRadius: "0.5rem",
    marginTop: theme.spacing(2),
  },

  item: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'start',
    alignItems: 'center',
    width: '80%',
    //backgroundColor:'yellow'
  },

}));




export default function OrderResent(props) {
  const classes = useStyles();
  const {link, phone, message, strings} = props;
  const [open, setOpen] = useState(false)
 
 
  const handlerCopyInfo = (key)=>{
    navigator.clipboard.writeText(key)
    setOpen(true);
  }


  const handleClose = () => {
    setOpen(false);
  };
  
  return (
   
      <div className={classes.rowResent}>
         
         <Typography 
                  variant='body1'
                  align='left'
                  className={classes.message}>
                    {message}
                </Typography>
              
      

         <div className={classes.rowItem}>
                  <div className={classes.item}>    
                    <WhatsApp/>
                    <Typography variant='body1' mx={1} > {phone} </Typography>        
                  </div>
                <ContentCopyOutlined
                  onClick ={()=> handlerCopyInfo(phone)}/>
        </div>
        <div className={classes.rowItem}>
                  <div className={classes.item}>    
                    <ReceiptOutlined/>
                    <Typography noWrap variant='body1' mx={1} > {link} </Typography>        
                  </div>
                <ContentCopyOutlined
                  onClick ={()=> handlerCopyInfo(link)}/>
        </div>

        <Snackbar
          open={open}
          autoHideDuration={2000}
          onClose={handleClose}
          message={strings.copied_clipboard}
        />
      </div>
  );
}
